import React from 'react';
import { Heading, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { MobileDesktopSetupNotice } from './MobileDesktopSetupNotice';
import { postPurchaseBi } from '../postPurchaseBi';
import { CONNECT_DOMAIN_VIDEO_EMBED_URL } from '../helpers';
import { SetupVideoIcon } from './icons';
import { DomainRow } from './DomainRow';
import { EmbeddedVideoPlayer } from './EmbeddedVideoPlayer';
import styles from '../PostPurchaseStep.scss';

interface DomainPanelProps {
  domainValue: string;
  hasPremiumDomain: boolean;
  isMobile: boolean;
  metaSiteId: string | null;
  suggestedDomain: string;
  onDomainValueChange: (value: string) => void;
}

export function DomainPanel({
  domainValue,
  hasPremiumDomain,
  isMobile,
  metaSiteId,
  suggestedDomain,
  onDomainValueChange,
}: DomainPanelProps) {
  const { t } = useTranslation();

  return (
    <section
      className={`${styles.postPurchasePanel} ${styles.postPurchaseDomainPanel}`}
      aria-label={t('post_purchase.domain.video_aria')}
    >
      <div className={styles.postPurchaseSetupGrid}>
        <article className={styles.postPurchaseSetupVideo}>
          <div className={styles.postPurchaseSetupCopy}>
            <SetupVideoIcon />
            <Heading as="h2" size="medium">
              {t('post_purchase.domain.panel_title')}
            </Heading>
            <Text size="small" secondary className={styles.postPurchaseDomainDescription}>
              {hasPremiumDomain ? t('post_purchase.domain.done_description') : t('post_purchase.domain.description')}
            </Text>
            {!hasPremiumDomain &&
              (isMobile ? (
                <MobileDesktopSetupNotice />
              ) : (
                <DomainRow
                  value={domainValue}
                  onChange={onDomainValueChange}
                  metaSiteId={metaSiteId}
                  buttonLabel={t('post_purchase.cta.lets_go')}
                  placeholder={suggestedDomain}
                  onConnectClick={postPurchaseBi.connectDomain}
                />
              ))}
          </div>
          <div className={styles.postPurchaseSetupMedia}>
            <EmbeddedVideoPlayer src={CONNECT_DOMAIN_VIDEO_EMBED_URL} title={t('post_purchase.domain.panel_title')} />
          </div>
        </article>
      </div>
    </section>
  );
}
